// Split only long untranslated lines; a translation belongs to its whole sentence.
// Timed words keep their original timestamps. Plain LRC uses the next line as
// a bounded estimate and never invents a split when that timing is unavailable.
export function splitLongLyricLines(lines) {
  const result = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const text = line.words?.length ? line.words.map((word) => word.text).join("") : line.text || "";
    if (line.translation || text.replace(/\s/g, "").length < 18) {
      result.push(line);
      continue;
    }
    const wordEnds = [];
    let length = 0;
    for (const word of line.words || []) {
      length += word.text.length;
      wordEnds.push(length);
    }
    const cuts = [];
    for (let at = 1; at < text.length - 1; at++) {
      let cut = -1;
      if (/[，。！？；,!?;]/.test(text[at - 1])) cut = at;
      else if (/\s/.test(text[at - 1]) && /[\p{Script=Han}]/u.test(text.slice(0, at).trimEnd().at(-1) || "") &&
        /[\p{Script=Han}]/u.test(text.slice(at).trimStart()[0] || ""))
        cut = at;
      if (cut < 0) continue;
      if (line.words?.length) cut = wordEnds.find((end) => end >= cut) || -1;
      if (cut > 0 && cut < text.length && !cuts.includes(cut)) cuts.push(cut);
    }
    const starts = [0];
    for (const cut of cuts)
      if (text.slice(starts.at(-1), cut).replace(/\s/g, "").length >= 8 &&
          text.slice(cut).replace(/\s/g, "").length >= 8)
        starts.push(cut);
    if (starts.length === 1) {
      result.push(line);
      continue;
    }
    const nextTime = lines[i + 1]?.time;
    const span = nextTime - line.time;
    if (!line.words?.length && (!Number.isFinite(span) || span < 1.4)) {
      result.push(line);
      continue;
    }
    const parts = starts.map((start, index) => {
      const end = starts[index + 1] ?? text.length;
      if (line.words?.length) {
        const begin = wordEnds.findIndex((value) => value > start);
        const finish = wordEnds.findIndex((value) => value >= end);
        const words = line.words.slice(begin, finish + 1);
        return { time: words[0]?.time ?? line.time,
          text: words.map((word) => word.text).join("").trim(), words };
      }
      const before = text.slice(0, start).replace(/\s/g, "").length;
      const total = text.replace(/\s/g, "").length;
      return { time: line.time + 0.85 * span * before / total,
        text: text.slice(start, end).trim() };
    });
    const merged = [];
    for (const part of parts) {
      const previous = merged.at(-1);
      if (previous && (part.time - previous.time < 0.5 || part.text.length < 2)) {
        previous.text = (previous.text + " " + part.text).trim();
        if (previous.words) previous.words.push(...part.words);
      } else merged.push(part);
    }
    if (merged.length > 1 && Number.isFinite(nextTime) && nextTime - merged.at(-1).time < 0.5) {
      const last = merged.pop();
      merged.at(-1).text = (merged.at(-1).text + " " + last.text).trim();
      if (merged.at(-1).words) merged.at(-1).words.push(...last.words);
    }
    result.push(...(merged.length > 1 ? merged : [line]));
  }
  return result;
}
